// cdn hosts
export const cdnHosts = [
  'liblibai-online.liblib.cloud',
  'model-ai-test.liblib.cloud',
  'liblibai-online.liblib.ai',
  'model-ai-test.liblib.ai',
  'liblibai-gen-images.liblib.cloud',
  'liblibai-tmp-image.liblib.cloud',
  'model-ai-test.vibrou.com',
  'models-online-persist.shakker.cloud',
];

export const awsCdnHost = ['models-online-persist.shakker.ai'];
